import { MainCategoriesCoursesViewSkeleton } from '@crehana/compass.knowledgehub';
import dynamic from 'next/dynamic';

const LazyKnowledgeHubHomeSection = dynamic(
  () => import('./KnowledgeHubHomeSection'),
  {
    loading: () => <MainCategoriesCoursesViewSkeleton />,
  },
);

export default LazyKnowledgeHubHomeSection;
